console.log('env config: ', process.env);
export default {
  url: process.env.REACT_APP_BASE_URL || 'https://mygenes.codev.co.il/',
  deliveryHost:
    process.env.REACT_APP_DELIVERY_HOST ||
    'https://test.hfd.co.il/IFrame_TimeWindow/form1.php',
  appointmentHost:
    process.env.REACT_APP_APPOINTMENT_HOST ||
    'https://www.tor4you.co.il/edstn.asp?siteid=15978&sid=84E608E0213C0A06'
};
